module.exports = __webpack_public_path__ + "static/5-f84477d29899d372fc37a51640948a10.png";